import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full text-white mb-6 border border-white/20">
            <Shield className="w-4 h-4" />
            <span className="text-sm font-medium">Global Child Protection Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Protecting Children
            <span className="block text-blue-300">Worldwide</span>
          </h1>

          <p className="text-xl md:text-2xl text-blue-50 mb-8 leading-relaxed">
            Expert consultations, professional training, and prevention education 
            for communities committed to safeguarding children from abuse and neglect.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              onClick={scrollToContact}
              className="bg-white text-blue-900 hover:bg-blue-50 text-lg px-8 py-6 h-auto font-semibold"
            >
              Request Consultation
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              onClick={scrollToServices}
              className="border-2 border-white text-white hover:bg-white/10 text-lg px-8 py-6 h-auto font-semibold backdrop-blur-sm"
            >
              Our Services
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-16 pt-8 border-t border-white/20">
            <div>
              <div className="text-4xl font-bold text-white mb-2">195</div>
              <div className="text-blue-200 text-sm">Countries Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-200 text-sm">Support Available</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">7</div>
              <div className="text-blue-200 text-sm">Languages</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
